<template>
  <div class="main-info">
    <h6 v-for="(iK, key) in infoKeys" :key="key">
      <span class="text-danger"> {{ iK.title | setText(iK.title) }}: </span>
      <span v-if="iK.value">{{ iK.value }}</span>
      <span v-else-if="iK.dateFormat">{{ value(iK) | dateFormat }}</span>
      <span v-else>{{ value(iK) }}</span>
    </h6>
  </div>
</template>

<script>

export default {

  props: {
    item:{
      default:function(){
        return {};
      }
    },
    infoKeys:{
      default:function(){
        return [];
      }
    },
  },
  methods:{
    value(iK){
      try {
         let value = iK.object ? this.item[iK.object][iK.key] : this.item[iK.key] ;
         return value;
      } catch (error) {
        return 'Не установлено';
      }
    }
  }
 
};
</script>
<style lang="scss">
  .main-info {
      display: flex;
        align-items:center;
                    flex-wrap: wrap;
    justify-content:left;
    margin-bottom:20px;
    &  h6 {
      margin-bottom:5px;
        margin-right:20px;

                text-transform: uppercase;
          max-width: 100%;
          white-space: nowrap;
    }
  }
</style>
